"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_COMPLETED_STEP_NUM = exports.DEFAULT_WEEKLY_AVAILBLE_TIMES = exports.ANY_WEEKLY_AVAILBLE_TIMES = exports.CollectionName = void 0;
__exportStar(require("./addParamToUrl"), exports);
__exportStar(require("./allDayEventClamper"), exports);
__exportStar(require("./allDayEventCoordinateCoder"), exports);
__exportStar(require("./allDayEventDecorator"), exports);
__exportStar(require("./arrayUtil"), exports);
__exportStar(require("./bookingURLDecoder"), exports);
__exportStar(require("./bookingURLEncoder"), exports);
__exportStar(require("./buildOauthState"), exports);
__exportStar(require("./calcAvailablePeriods/calcAvailablePeriods"), exports);
__exportStar(require("./calcPeriodOnPeriod"), exports);
__exportStar(require("./clampDate"), exports);
__exportStar(require("./clampPeriod"), exports);
var collectionName_1 = require("./collectionName");
Object.defineProperty(exports, "CollectionName", { enumerable: true, get: function () { return collectionName_1.CollectionName; } });
__exportStar(require("./commonOauthState"), exports);
__exportStar(require("./compareDateByTime"), exports);
__exportStar(require("./convertTZ"), exports);
__exportStar(require("./dateCoder"), exports);
__exportStar(require("./dateFilter"), exports);
__exportStar(require("./dateUtil"), exports);
__exportStar(require("./dividePeriodByMinutes"), exports);
__exportStar(require("./excludeAllDayEventFilter"), exports);
__exportStar(require("./excludeKeywordFilter"), exports);
__exportStar(require("./form"), exports);
__exportStar(require("./formToDescription"), exports);
__exportStar(require("./formatRFC3339woZ"), exports);
__exportStar(require("./formulaAvailablePeriodsCalculator"), exports);
__exportStar(require("./generateDateAndTimeRangePeriods"), exports);
__exportStar(require("./groupPeriodsBy"), exports);
__exportStar(require("./mapPlaceId"), exports);
__exportStar(require("./movePeriodOnPeriod"), exports);
__exportStar(require("./noScheduleEventFilter"), exports);
__exportStar(require("./numberToDayName"), exports);
__exportStar(require("./oauthState"), exports);
__exportStar(require("./overdayEventDivider"), exports);
__exportStar(require("./parseEmail"), exports);
__exportStar(require("./period"), exports);
__exportStar(require("./periodCoordinateCoder"), exports);
__exportStar(require("./periodFilters"), exports);
__exportStar(require("./periodFilters/divideOverDayPeriodFilter"), exports);
__exportStar(require("./periodJoiner"), exports);
__exportStar(require("./periodWithId"), exports);
__exportStar(require("./periods"), exports);
__exportStar(require("./removeItem"), exports);
__exportStar(require("./shortenResourceCalendarTitle"), exports);
__exportStar(require("./sortBy"), exports);
__exportStar(require("./stripe"), exports);
__exportStar(require("./timeLineEventCoordinateCoder"), exports);
__exportStar(require("./timeLineEventDecorator"), exports);
__exportStar(require("./tpb"), exports);
__exportStar(require("./undecidedEventFilter"), exports);
__exportStar(require("./uriDoubleCoder"), exports);
__exportStar(require("./userPlanAvailability"), exports);
__exportStar(require("./validateBookingPageByPlan"), exports);
__exportStar(require("./workingHourConverter"), exports);
const ANY_DAILY_AVAILABLE_TIMES = {
    available: true,
    times: [
        {
            startTime: {
                hour: 0,
                min: 0
            },
            endTime: {
                hour: 23,
                min: 59
            }
        }
    ]
};
exports.ANY_WEEKLY_AVAILBLE_TIMES = {
    mon: ANY_DAILY_AVAILABLE_TIMES,
    tue: ANY_DAILY_AVAILABLE_TIMES,
    wed: ANY_DAILY_AVAILABLE_TIMES,
    thu: ANY_DAILY_AVAILABLE_TIMES,
    fri: ANY_DAILY_AVAILABLE_TIMES,
    sat: ANY_DAILY_AVAILABLE_TIMES,
    sun: ANY_DAILY_AVAILABLE_TIMES,
    hol: ANY_DAILY_AVAILABLE_TIMES
};
// WARNING:
// 初めこれを定数の代入にして参照していたら、月曜〜金曜まで参照が
// 共有されてしまって、めちゃくちゃハマった。
// この辺り読んでJavaScriptの値の保持の仕方はあらためて理解しておいた方がいい。
// https://www.notion.so/JavaScript-a3f323558dcb43b9983ce0296826aabc
const DEFAULT_DAILY_AVAILABLE_TIMES = (available) => ({
    available,
    times: [
        {
            startTime: {
                hour: 10,
                min: 0
            },
            endTime: {
                hour: 18,
                min: 0
            }
        }
    ]
});
exports.DEFAULT_WEEKLY_AVAILBLE_TIMES = {
    mon: DEFAULT_DAILY_AVAILABLE_TIMES(true),
    tue: DEFAULT_DAILY_AVAILABLE_TIMES(true),
    wed: DEFAULT_DAILY_AVAILABLE_TIMES(true),
    thu: DEFAULT_DAILY_AVAILABLE_TIMES(true),
    fri: DEFAULT_DAILY_AVAILABLE_TIMES(true),
    sat: DEFAULT_DAILY_AVAILABLE_TIMES(false),
    sun: DEFAULT_DAILY_AVAILABLE_TIMES(false),
    hol: DEFAULT_DAILY_AVAILABLE_TIMES(false)
};
exports.ONBOARDING_COMPLETED_STEP_NUM = -1;
//# sourceMappingURL=index.js.map